import { useState } from "react";
import { faEnvelope } from "@fortawesome/pro-solid-svg-icons";

import { T } from "@repo/transifex";
import { useSalesReport, useSendEmailReport } from "~/hooks/queries/reports";
import { Button } from "~/components";

import { DialogSendReportEmail } from "./DialogSendReportEmail";

export const SendReportButton = ({ sessionId }: { sessionId: string }) => {
  const [open, setOpen] = useState(false);

  const { data, status: reportStatus } = useSalesReport(sessionId);
  const { mutate: sendReport, status, reset } = useSendEmailReport(sessionId);

  if (reportStatus === "error") return null;

  return (
    <>
      <Button
        className="w-full"
        icon={faEnvelope}
        loading={reportStatus === "pending"}
        onClick={() => {
          setOpen(true);
        }}
        size="large"
        variant="primary-light"
      >
        <T _str="Send report" />
      </Button>

      {data?.report ? (
        <DialogSendReportEmail
          onOutsideClick={() => {
            setOpen(false);
          }}
          onSubmit={(email) => {
            sendReport({ email });
          }}
          onClose={() => {
            setOpen(false);
            reset();
          }}
          status={status}
          open={open}
        />
      ) : null}
    </>
  );
};
